export enum SidebarStatus {
	Opened = 'opened',
	Closed = 'closed'
}
